import {WinPresentationController} from "../WinPresentationController";
import {TimelineLite} from "gsap";
import {TheRave} from "../../TheRave";
import {TheRaveParsedGameData} from "../../server/data/TheRaveParsedGameData";
import {Layers, TheRaveLayers} from "../../view/TheRaveLayers";
import {TheRaveSound} from "../../sound/TheRaveSound";

export class XSplitController extends WinPresentationController {

    private _tl: TimelineLite;

    constructor() {
        super("xSplitController", true);
    }

    protected hasWin(): boolean {
        return TheRave.model.parsedGameData.hasXSplit;
    }

    protected async createWinAnimation(): Promise<void> {
        const parsedGameData: TheRaveParsedGameData = TheRave.model.parsedGameData,
            tl = new TimelineLite();
        let counter: number = -1;
        parsedGameData.evaluatedArea.forEach((syms, reelId) => {
            const xsId: number = syms.indexOf("XS");
            if (xsId > -1) {
                counter++;
                const verticalSplitTl: TimelineLite = new TimelineLite();
                const laserEffect0: PIXI.spine.Spine = this.createLaserEffect(reelId, xsId);
                const laserEffect1: PIXI.spine.Spine = this.createLaserEffect(reelId, xsId);

                verticalSplitTl.add([
                    TheRave.reels[reelId].getSymbol(0).addSplitSymbolAnimation(1, false, (Math.abs(xsId - 0) * 0.3)),
                    TheRave.reels[reelId].getSymbol(1).addSplitSymbolAnimation(1, false, (Math.abs(xsId - 1) * 0.3)),
                    TheRave.reels[reelId].getSymbol(2).addSplitSymbolAnimation(1, false, (Math.abs(xsId - 2) * 0.3)),
                    () => {
                        TheRaveSound.playSoundEffect("xSplitSlicing");
                        laserEffect0.state.setAnimation(0, `vR02`, false);
                        laserEffect0.visible = true;
                        if(xsId === 1){
                            laserEffect1.scale.y = 1;
                            laserEffect1.state.setAnimation(0, `vR02`, false);
                            laserEffect1.visible = true;
                        }
                    }], 0);

                verticalSplitTl.add(() => this.recycleLaserEffect(laserEffect0),0.5);
                verticalSplitTl.add(() => this.recycleLaserEffect(laserEffect1),0.5);
                tl.add(verticalSplitTl, counter * 0.1);
                if(TheRave.model.isFreespin){
                    tl.add(() => {TheRave.stickySymbol.updateSingleMultiplier(reelId)}, counter * 0.1+0.2);
                }
            }
        });

        this._tl = tl;
        tl.to(this, {duration: 0.1});
        // TODO: Tl sanity
        await Promise.resolve(this._tl);
        TheRave.ways.xSplit();
    }

    private createLaserEffect(reelId: number, symbolId: number): PIXI.spine.Spine {
        const position = TheRave.reels[reelId].getSymbol(symbolId, false, false).getStagePosition(),
            laserEffect: PIXI.spine.Spine = new PIXI.spine.Spine(TheRave.assetLoader.getSpineAsset("XSHB"));
        laserEffect.name = "splitLaserEffectV";
        laserEffect.pivot.set(0.5, 0.5);
        laserEffect.scale.y = (symbolId === 0?1:-1);
        laserEffect.autoUpdate = true;
        laserEffect.visible = false;
        laserEffect.position.set(position.x, position.y);

        TheRaveLayers.getLayer(Layers.WIN_PRESENTATIONS)!.addChild(laserEffect);
        return laserEffect
    }

    private recycleLaserEffect(effect: PIXI.spine.Spine): void {
        effect.state.setEmptyAnimation(0, 0);
        TheRaveLayers.getLayer(Layers.WIN_PRESENTATIONS)!.removeChild(effect);
    }

    public skip(): void {
        this._tl.timeScale(2);
    }
}